<template>
  <div class="search-picker-modal">
    <modal
      :name="modalName"
      :adaptive="true"
      width="100%"
      height="100%"
      class="vacancy-modal-component"
      :scrollable="true"
    >
      <template slot="top-right">
        <button
          class="modal-close"
          type="button"
          :aria-label="$t('common:closeDatepicker')"
          @click="$modal.hide(modalName)"
        >
          <i
            class="icon"
          >
            <icon-times />
          </i>
        </button>
      </template>

      <flat-pickr-base
        v-model="fpModelValue"
        :extended-input-emit="true"
        :inline="true"
        :month-count="calendarMonthCount"
        :month-navigation="true"
        :max-duration="28"
        @on-change="mobileDateChanged"
      />

      <button
        class="btn btn-primary btn-block mt-3 mb-2"
        type="button"
        @click="$modal.hide(modalName)"
      >
        <i class="icon"><icon-check /></i>
        {{ $t('common:button.picker_modal_submit') }}
      </button>
    </modal>
  </div>
</template>

<script>
import FlatPickrBase from 'components/FlatPickrBase.vue';
import ObjectPriceModels from 'mixins/ObjectPriceModels';
import ActiveObjectStore from 'mixins/ActiveObjectStore';

/* ICONS */
import IconCheck from 'ICON:IconCheck';
import IconTimes from 'ICON:IconTimes';

import FlatpickrSearchFunctions from 'mixins/FlatpickrSearchFunctions';
import {
  install, deinstall, isMobile, calendarMonthCount, modalName,
} from 'mixins/composition/PickerModal';
import { onMounted, onUnmounted } from '@vue/composition-api';

/**
 * @@author        j0Shi
 * @@date          2019.09.24
 * @@desc          Mobile modal to pick the calendar date
 * @@usedby        Object -> ObjectBookingBand
 */
export default {
  name: 'SearchPickerModal',
  components: {
    FlatPickrBase,
    IconCheck,
    IconTimes,
  },
  mixins: [
    // v-models for picker and persons input
    ObjectPriceModels,
    // active object store helper
    ActiveObjectStore,
    // flatpickr handling
    FlatpickrSearchFunctions,
  ],
  props: {
    // vacancy data for the picker
    pickerVacancyData: {
      type: Object,
      default: () => ({
        count: 0,
        days: {},
        maxDate: new Date(),
      }),
    },
    // marker to only update the page url or trigger search
    onlyFillStore: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    onMounted(() => {
      install();
    });

    onUnmounted(() => {
      deinstall();
    });

    return {
      isMobile,
      calendarMonthCount,
      modalName,
    };
  },
  watch: {
    isMobile: 'closeOnBreakpoint',
  },
  mounted() {
    this.$emit('modal-initialized', true);
  },
  methods: {
    // @vuese
    // closes the modal when we hit desktop view
    // this shouldn't happen too often in production as the user normally doesn't resize
    closeOnBreakpoint(newValue) {
      if (!newValue) this.$modal.hide(modalName);
    },
    mobileDateChanged(value) {
      this.$emit('on-change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'scss/components/flatpickr-modal.scss';
</style>
